import { PropsWithChildren, ReactNode } from 'react';

import { ProgressBar } from 'libs/ui';

import {
  ContentStyled,
  OnboardingHeaderStyled,
} from './OnboardingLayout.styles';

interface OnboardingLayoutProps extends PropsWithChildren {
  countSteps?: number;
  currentStepIndex?: number;
  headerComponent?: ReactNode;
}

export const OnboardingLayout = ({
  children,
  countSteps,
  currentStepIndex,
  headerComponent,
}: OnboardingLayoutProps) => (
  <>
    <OnboardingHeaderStyled>
      {headerComponent === undefined ? (
        <ProgressBar
          className="onboardingLayout-progressBar"
          countSteps={countSteps}
          currentStepIndex={currentStepIndex}
        />
      ) : (
        headerComponent
      )}
    </OnboardingHeaderStyled>
    <ContentStyled>{children}</ContentStyled>
  </>
);
